module.exports = __webpack_public_path__ + "static/fernando-3c8826c504d6d14fa5ea326e570b73d5.jpg";